// Import auth utilities
import { checkResponseStatus } from '../utils/authUtils';

export async function login({ email, password, remember_me }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  console.log(API_BASE_URL);
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }
  console.log('Making login request to:', `${API_BASE_URL}api/v1/dashboard/auth/login`);
  const response = await fetch(`${API_BASE_URL}api/v1/dashboard/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password, remember_me }),
  });
  if (!response.ok) {
    let errorMessage = 'Login failed';
    try {
      const error = await response.json();
      errorMessage = error.message || errorMessage;
    } catch (e) {
      const errorText = await response.text();
      console.error('Non-JSON response:', errorText);
      errorMessage = `Server error: ${response.status} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function logout() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }
  const response = await fetch(`${API_BASE_URL}api/v1/dashboard/auth/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    },
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    let errorMessage = 'Logout failed';
    try {
      const error = await response.json();
      errorMessage = error.message || errorMessage;
    } catch (e) {
      const errorText = await response.text();
      errorMessage = `Server error: ${response.status} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function fetchUserPermissions() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const response = await fetch(`${API_BASE_URL}api/v1/dashboard/permission/list-user-permission`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    },
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    let errorMessage = 'Failed to fetch user permissions';
    try {
      const error = await response.json();
      errorMessage = error.message || errorMessage;
    } catch (e) {
      const errorText = await response.text();
      errorMessage = `Server error: ${response.status} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }

  return response.json();
}
